query ListAccountUsagePage($limit: Int, $nextToken: String, $sort: String, $plan: String, $paid: Boolean, $suspended: Boolean, $youtube: String, $search: String) {
  page: StreamToolsListAccountUsagePage(limit: $limit, nextToken: $nextToken, sort: $sort, plan: $plan, paid: $paid, suspended: $suspended, youtube: $youtube, search: $search) {
    items {
      accountId
      email
      tier
      createdAt
      suspendedAt
      estimatedCents
      ytQuotaPctOfMonthlyBudget
      billingSource
      cancelAtPeriodEnd
      currentPeriodEnd
      events {
        used
        cap
      }
      chatOverlays {
        used
        cap
      }
      emoteWalls {
        used
        cap
      }
      storageBytes {
        used
        cap
      }
      currentMonthUsage {
        votesIngested
      }
    }
    nextToken
    orderMode
    rankedAt
    approxTotal
  }
}
